/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {stateTitleView} from '../common/directives/html/state-title.component';
import {PaymentRoutePageComponent} from './payment-route-page.component';
import {emptyRouteView} from '../common/directives/html/route-view-components';


export function paymentStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
$stateProvider.state('app.rep.payments', {
          url: '/payments',
          views: {
            'content@app': {
              component: PaymentRoutePageComponent
            },
            'context@app': emptyRouteView(),
            'title@app': stateTitleView()
          },
          data: {
            title: "payment.plural"
          }
        });
  }, adnRouterHelper);
}
